export default __webpack_public_path__ + "static/media/assetTypes.93faec65.svg";